
import { TableConfig, DataTable } from "@app/interfaces";

export class ConductListTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: true,
            groupPanel: false,
            canEdit: false,
            showPagination: {
                showPageSizeSelector: true,
                pageSize: 10,
                allowedPageSizes: [10, 25, 50, 100]
            },
            fields: [
                {
                    caption: 'Name',
                    dataField: 'name'
                },
                {
                    caption: 'Survey',
                    dataField: 'survey.name'
                },
                {
                    caption: 'Client',
                    dataField: 'userName'
                },
                {
                    caption: 'Done By',
                    dataField: 'creactedByName'
                },
                {
                    caption: 'Archive',
                    dataField: 'archived'
                },
                {
                    caption: 'Created At',
                    format: "dd MMM, yyyy",
                    dataType: "date",
                    dataField: 'createdAt'
                },
                {
                    caption: 'Clone',
                    width: 60,
                    cellTemplate: {
                        id: 'itemsActionButtons1',
                        buttons: [{
                            icon: 'fa-solid fa-copy',
                            name: "Copy",
                            eventName: "copy",
                            cssClass: "me-2"
                        }],
                    },
                },
                {
                    caption: 'Details',
                    width: 60,
                    cellTemplate: {
                        id: 'itemsActionButtons',
                        buttons: [{
                            icon: 'fa-solid fa-arrow-right',
                            name: "Details",
                            eventName: "details",
                            cssClass: "me-2"
                        }],
                    },
                },
            ]
        };

        return tableConfig;

    }

}